import { render, staticRenderFns } from "./Chat.svg.vue?vue&type=template&id=47959b58"
import script from "./Chat.svg.vue?vue&type=script&lang=ts"
export * from "./Chat.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47959b58')) {
      api.createRecord('47959b58', component.options)
    } else {
      api.reload('47959b58', component.options)
    }
    module.hot.accept("./Chat.svg.vue?vue&type=template&id=47959b58", function () {
      api.rerender('47959b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Chat.svg.vue"
export default component.exports